module.exports = __webpack_public_path__ + "files/3f17bcd0ba2f0353e5266ab0b685c299.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/pdf.svg
// module id = 588
// module chunks = 27